import { toast } from 'sonner';

import { UiToastAdded } from '../UiToastAdded';

import type { ToastCompareAddedParams } from './types';

export const toastCompareAdded = ({
  src,
  subtitle,
  position = 'top-right',
  style,
  title,
  buttonText
}: ToastCompareAddedParams) => {
  toast.custom(
    () => (
      <div
        style={{ pointerEvents: 'auto' }}
        onClick={() => {
          toast.dismiss();
        }}
      >
        <UiToastAdded
          src={src}
          subtitle={subtitle}
          title={title}
          buttonText={buttonText}
          buttonHref="/account/compare"
        />
      </div>
    ),
    { position, style }
  );
};
